import { Box, Typography, Grid, Card, CardContent, CardActions, Button } from "@mui/material";
import { useEffect } from "react";

export default function Resources({ onClose }) {
    // Handle escape key to close
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };
        
        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, [onClose]);

    const resources = [
        {
            title: "USER GUIDE",
            description: "Understand how to navigate and utilize the State of the Agrifood Systems Data Platform effectively with this comprehensive user guide.",
            pdf: "https://storage.googleapis.com/fao-cca-archive/resources/User%20Guide.pdf"
        },
        {
            title: "METADATA",
            description: "Explore the metadata associated with the State of the Agrifood Systems Data Platform, providing insights into the data content and structure.",
            pdf: "https://storage.googleapis.com/fao-cca-archive/resources/General%20Metadata%20Table_Sep2025.pdf"
        },
        {
            title: "BACKGROUND DOCUMENTS",
            description: "Understand the context and background of the State of the Agrifood Systems Data Platform with these background documents.",
            pdf: "https://storage.googleapis.com/fao-cca-archive/resources/AFS%20Indicator%20Framework%20for%20SCOPE.pdf"
        },
    ];

    return (
        <Box
            sx={{
                position: "fixed",
                top: {
                    xs: "var(--header-height-mobile)",
                    md: "var(--header-height-desktop)"
                },
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1300,
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Gradient overlay background */}
            <Box
                sx={(theme) => ({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: theme.palette.mode === "dark"
                        ? "linear-gradient(to bottom, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.85) 70%, rgba(0, 0, 0, 0.25) 100%)"
                        : "linear-gradient(to bottom, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 70%, rgba(255, 255, 255, 0.25) 100%)",
                    backdropFilter: "blur(4px)",
                })}
                onClick={onClose}
            />

            {/* Content container */}
            <Box
                sx={{
                    position: "relative",
                    zIndex: 1,
                    maxWidth: "1200px",
                    width: "100%",
                    margin: "0 auto",
                    padding: { xs: "20px", md: "40px" },
                    overflowY: "auto",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Page title */}
                <Typography variant="h3" fontWeight="bold" gutterBottom sx={{ mt: 2 }}>
                    Resources
                </Typography>

                {/* Cards section */}
                <Grid container spacing={3} sx={{ mt: 2 }}>
                    {resources.map((res, index) => (
                        <Grid item xs={12} md={4} key={index}>
                            <Card sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Typography variant="h6" gutterBottom>
                                        {res.title}
                                    </Typography>
                                    <Typography variant="body1">
                                        {res.description}
                                    </Typography>
                                </CardContent>
                                <CardActions sx={{ mt: "auto" }}>
                                    <Button
                                        size="large"
                                        variant="contained"
                                        color="primary"
                                        href={res.pdf}
                                        target="_blank"
                                        fullWidth
                                    >
                                        Learn More
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}
